import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import '@fontsource/space-grotesk/latin-400.css';
import '@fontsource/space-grotesk/latin-500.css';
import '@fontsource/space-grotesk/latin-600.css';
import '@fontsource/space-grotesk/latin-700.css';
import '@fontsource/space-grotesk/latin-ext-400.css';
import '@fontsource/space-grotesk/latin-ext-700.css';
import '@fontsource/ibm-plex-mono/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-500.css';
import '@fontsource/ibm-plex-sans-arabic/arabic-400.css';
import '@fontsource/ibm-plex-sans-arabic/arabic-600.css';
import '@fontsource/ibm-plex-sans-arabic/arabic-700.css';
import '@fontsource/ibm-plex-sans-arabic/latin-400.css';
import './styles.css';
import { App } from './App';
import { parseLocation } from './routes';

const container = document.getElementById('root')!;
const { route, lang } = parseLocation(window.location.pathname);
const app = (
  <StrictMode>
    <App route={route} lang={lang} />
  </StrictMode>
);

const matchesPrerender =
  container.hasChildNodes() && container.dataset.route === route && container.dataset.lang === lang;

if (matchesPrerender) {
  hydrateRoot(container, app);
} else {
  container.textContent = '';
  createRoot(container).render(app);
}
document.documentElement.classList.remove('csr');
